(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('roles', {
            parent: 'application',
            url: '/roles',
            data: {
                authorities: ['ROLE_RESOURCE'],
                pageTitle: 'Role - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/roles/roles.html',
                    controller: 'RolesController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
